import React, { useState, useEffect, useContext, useRef, createRef } from "react";
import Modal from 'react-bootstrap/Modal';
import Context from "../../../../context/Context";
import Button from "@mui/material/Button";
import blogFetch from "../../../../axios/config";
import './styles.css'
import { Autocomplete, Switch, TextField } from "@mui/material";

const INITIAL_VALUE = {
  Origem_Grupo: null,
  Origem_Cod: null,
  Defeito_Grupo: null,
  Defeito_Cod: null,
  Causa_Grupo: null,
  Causa_Cod: null,
  Molde_Pend_Mot_Key: null,
  Destino: null
}

export const ReasonModal = ({
  showReason,
  setShowReason,
  clickedItem,
  apontamentoStatus,
  getVagoesAnalise,
  index,
  resetIndex,
  putAprovadoVagao
}) => {


  console.log(apontamentoStatus);
  

  const [origins, setOrigins] = useState([]);
  const [groupDefects, setGroupDefects] = useState([]);
  const [defects, setDefects] = useState([]);
  const [causes, setCauses] = useState([]);
  // const [keyModel, setKeyModel] = useState([]);
  const [motivo, setMotivo] = useState([]);
  const [destino, setDestino] = useState([]);
  const [moldProblem, setMoldProblem] = useState(false);
  const [selectItems, setSelectItems] = useState(INITIAL_VALUE);
  const [isButtonDisabled, setIsButtonDisabled] = useState(true);
  const [obs, setObs] = useState("");
  const [error, setError] = useState('');


  useEffect(() => {
    if (moldProblem) {
      GetMotivo()
    }
  }, [moldProblem]);  

  useEffect(() => {
    GetOriginBySector()
    if (selectItems.Origem_Grupo) {
      GetGroupDefectByOrigin()
      if(apontamentoStatus = "REPROCESSO") {
        GetDestino(clickedItem.ordem_Serial)
      }
    }
    if (selectItems.Defeito_Grupo) {
      GetDefectByGroupDefect()
    }
    if (selectItems.Defeito_Cod) {
      GetCausesByDefect()
    }
  }, [selectItems.Origem_Grupo, selectItems.Defeito_Grupo, selectItems.Defeito_Cod]);

  const {
    getConfirmedWagon,
    selectedFurnace,
    loadingFullScreen,
    loading,
    setLoading
  } = useContext(Context);

  useEffect(() => {
    setIsButtonDisabled(disableButton)
  }, [selectItems, obs]);

  const disableButton = () => {
    const { Molde_Pend_Mot_Key, Destino, ...otherFields } = selectItems;

    if (obs.length > 40) {
      return true;
    }
  
    if (apontamentoStatus === "REFUGO") {
      return Object.values(otherFields).some(value => value === null);
    }
    
    return Object.values({ Destino, ...otherFields }).some(value => value === null);
  }; 

  const GetMotivo = async () => {
    try {
      const { data } = await blogFetch.get(`/ISAGA_MoldePendenciasMotivo`);
      setMotivo(data);

    } catch (error) {
      console.error(error);
    };
  };

  const GetOriginBySector = async () => {
    try {
      const { data } = await blogFetch.get(`/CatalogoDefeitos/Origin/06CURVAD`);
      setOrigins(data);
    } catch (error) {
      console.error(error);
    };
  };

  const GetGroupDefectByOrigin = async () => {
    try {
      const { data } = await blogFetch.get(
        `/CatalogoDefeitos/GroupDefect?origin=${selectItems.Origem_Grupo}&sector=06CURVAD`
      );
      setGroupDefects(data);
    } catch (error) {
      console.error(error);
    };
  };

  const GetDefectByGroupDefect = async () => {
    try {
      const { data } = await blogFetch.get(
        `/CatalogoDefeitos/Defect?origin=${selectItems.Origem_Grupo}&sector=06CURVAD&grupoDefeito=${selectItems.Defeito_Grupo}`
      );
      setDefects(data);
    } catch (error) {
      console.error(error);
    };
  };

  const GetCausesByDefect = async () => {
    try {
      const { data } = await blogFetch.get(
        `/CatalogoDefeitos/Cause?defect=${selectItems.Defeito_Cod}&origin=${selectItems.Origem_Grupo}&sector=06CURVAD&grupoDefeito=${selectItems.Defeito_Grupo}`
      );
      setCauses(data);
    } catch (error) {
      console.error(error);
    };
  };

  // const GetModelKeysByOrderAndSector = async () => {
  //   try {
  //     const { data } = await blogFetch.get(
  //       `/Desenho?order=${clickedItem.ordem_Serial}&sector=06CURVAD`
  //     );
  //     setKeyModel(data);
  //   } catch (error) {
  //     console.error(error);
  //   };
  // };

  const GetDestino = async (ordem) => {
    try {
      const { data } = await blogFetch.get(
        `SAGA_Roteiros/${ordem}`
      );
      setDestino(data);
    } catch (error) {
      console.error(error);
    };
  };

  const getUserMatricula = () => {
    const nro_matricula = JSON.parse(localStorage.getItem('user'))
    const userSAPMatricula = nro_matricula['user_SAPMatricula'];
    return userSAPMatricula
  }

  const putPeca = async () => {
    try {
      await blogFetch.put(`/ISAGA_VagoesFornosPecas`, {
        Vagao_Key: clickedItem.vagoes_Fornos.vagao_Key,
        Ordem_Serial: clickedItem.ordem_Serial,
        Status: moldProblem ? apontamentoStatus : "APROVADO",
        Molde_Key: clickedItem.molde_Key,
        Status_Peca: apontamentoStatus
      });
    } catch {

    } finally {

    }
  }

  const putMolde = async () => {
    try {
      await blogFetch.put(`/ISAGA_Moldes`, {
        molde_Key: clickedItem.molde_Key,
        molde_Status: "MANUTENCAO",
      });
    } catch {

    } finally {

    }
  }

  const postMoldePendencia = async () => {
    try {
      await blogFetch.post(`ISAGA_MoldePendencias`, {
        Molde_Key: clickedItem.molde_Key,
        Molde_Pend_Status: "ABERTO",
        Molde_Pend_Mot_Key: selectItems.Molde_Pend_Mot_Key,
        Molde_Pend_Obs: ""
      });
    } catch {

    } finally {

    }
  }

  const ApontSap = async () => {

    const userSAPMatricula = getUserMatricula();

    try {
      await blogFetch.post(`ISAGA_ApontamentoSAP?furnace=${selectedFurnace}`, {
        Centro_Trabalho: "06CURVAD",
        Ordem_Fabricacao: clickedItem?.ordem_Serial,
        Chave_Modelo: "SALH",
        Operacao: "1000",
        Tipo_Apontamento: apontamentoStatus,
        Defeito_Grupo: selectItems.Defeito_Grupo,
        Defeito_Cod: selectItems.Defeito_Cod,
        Origem_Grupo: selectItems.Origem_Grupo,
        Origem_Cod: selectItems.Origem_Cod,
        Causa_Grupo: selectItems.Causa_Grupo,
        Causa_Cod: selectItems.Causa_Cod,
        Nro_Matricula: userSAPMatricula,
        Observacao: obs,
        Destino: selectItems.Destino
      })
    } catch {

    } finally {
      setSelectItems(INITIAL_VALUE)
      setObs("")
    }
  }

  const PutPiecesByRForRP = async () => {
    setLoading(true)
    try {
      if (moldProblem) {
        await putMolde()
        await postMoldePendencia()
      }
      await ApontSap()
      resetIndex(index)
    } catch (e) {
      console.error(e)
    } finally {
      await putPeca()
      await putAprovadoVagao(clickedItem)
      await getVagoesAnalise()
      setLoading(false)
    }
  }

  const handleObsChange = (e) => {
    const value = e.target.value;
    if (value.length > 40) {
      setError('A observação não pode ter mais que 40 caracteres.');
    } else {
      setError('');
    }
    setObs(value);
  };

  return (

    <div className="d-flex justify-content-center px-5 py-2">
      <Modal backdrop="static" size="lg" show={showReason}>
        <h2 className="title_tables">
          {apontamentoStatus === "REFUGO" ? "REFUGO" : "REPROCESSO"}
        </h2>
        <Modal.Body
          className="pt-0" >
          <div className="table-fixed">
            <table className="table text-center">
              <thead>
                <tr>
                  <th>OP</th>
                  <th>PEÇA</th>
                  <th>VEÍCULO</th>
                  <th>PRODUTO</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{clickedItem?.ordem_Serial}</td>
                  <td>{clickedItem?.ordem_Part_Short}</td>
                  <td>{clickedItem?.ordem_VehDesc}</td>
                  <td>{clickedItem?.subProduto_Desc}</td>
                </tr>
              </tbody>
            </table>
          </div>

          <Autocomplete className="pb-2 color-autocomplete"
            disablePortal
            id="combo-box-demo"
            options={origins}
            getOptionLabel={(option) => `${option.cod_Origem} (${option.origem_Setor})`}
            onChange={(e, newValue) => setSelectItems({
              ...selectItems,
              Origem_Grupo: newValue.cod_Origem,
              Origem_Cod: newValue.cod_Defeito,
            })}

            renderInput={(params) =>
              <TextField
                {...params}
                label="Origem" />
            }
          />

          <Autocomplete className="pb-2 color-autocomplete"
            disablePortal
            id="combo-box-demo"
            options={groupDefects}
            getOptionLabel={(option) => `${option.cod_Grupo_Defeitos} (${option.grupo_Defeito})`}

            onChange={(e, newValue) => setSelectItems({
              ...selectItems,
              Defeito_Grupo: newValue.cod_Grupo_Defeitos,
            })}

            renderInput={(params) =>
              <TextField
                {...params}
                label="Grupo Defeito" />
            }
          />

          <Autocomplete className="pb-2 color-autocomplete"
            disablePortal
            id="combo-box-demo"
            options={defects}
            getOptionLabel={(option) => `${option.cod_Defeito} (${option.defeito})`}

            onChange={(e, newValue) => setSelectItems({
              ...selectItems,
              Defeito_Cod: newValue.cod_Defeito
            })}

            renderInput={(params) =>
              <TextField
                {...params}
                label="Defeito" />
            }
          />

          <Autocomplete className="pb-2 color-autocomplete"
            disablePortal
            id="combo-box-demo"
            options={causes}
            getOptionLabel={(option) => `${option.causa} (${option.cod_Causa})`}

            onChange={(e, newValue) => setSelectItems({
              ...selectItems,
              Causa_Grupo: newValue.cod_Origem,
              Causa_Cod: newValue.cod_Causa
            })}

            renderInput={(params) =>
              <TextField
                {...params}
                label="Causa" />
            }
          />

          {apontamentoStatus === "REPROCESSO" && (
            <Autocomplete className="pb-2 color-autocomplete"
              disablePortal
              id="combo-box-demo"
              options={destino}
              getOptionLabel={(option) => `${option}`}

              onChange={(e, newValue) => setSelectItems({
                ...selectItems,
                Destino: newValue
              })}

              renderInput={(params) =>
                <TextField
                  {...params}
                  label="Destino" />
              }
            />
          )}

<div>
      {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
      <textarea
        onChange={handleObsChange}
        value={obs}
        className="w-100"
        placeholder="OBSERVAÇÃO"
      />
    </div>

          {/* <Autocomplete className="pb-2 color-autocomplete"
            disablePortal
            id="combo-box-demo"
            options={keyModel}
            getOptionLabel={(option) => `${option.desenho_ClaveModelo}`}

            onChange={(e, newValue) => setSelectItems({
              ...selectItems,
              Chave_Modelo: newValue.desenho_ClaveModelo
            })}

            renderInput={(params) =>
              <TextField
                {...params}
                label="Chave Modelo" />
            }
          /> */}

          <div className="d-flex">
            <p>Problema causado por molde?</p>
            <Switch
              onChange={() => setMoldProblem(!moldProblem)}
            />
          </div>

          {moldProblem && (
            <Autocomplete className="pb-2 color-autocomplete"
              disablePortal
              id="combo-box-demo"
              options={motivo}
              getOptionLabel={(option) => `${option.molde_Pend_Mot_Descricao}`}

              onChange={(e, newValue) => setSelectItems({
                ...selectItems,
                Molde_Pend_Mot_Key: newValue.molde_Pend_Mot_Key
              })}

              renderInput={(params) =>
                <TextField
                  {...params}
                  label="Motivo" />
              }
            />
          )}

        </Modal.Body>

        <Modal.Footer>
          <Button
            // value={clickedItem.status_Peca}
            onClick={({ target }) => {
              // handleRadio(target, clickedItemKey, clickedItem)
              setShowReason(false)
              setSelectItems(INITIAL_VALUE)
              setMoldProblem(false)
              // getConfirmedWagon("FINALIZADO", selectedFurnace)
            }}
          >
            cancelar
          </Button>

          <Button
            onClick={() => {
              PutPiecesByRForRP()
              setShowReason(false)
              setMoldProblem(false)
            }}
            disabled={isButtonDisabled}
          >
            Confirmar
          </Button>
        </Modal.Footer>

      </Modal>
    </div>
  );
}